var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mycontainer-fluid body-wrapper"},[_c('div',{staticClass:"row myrow row-wrapper"})])
}]

export { render, staticRenderFns }